<template>
    <div>
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <!--还需要一个按房源名称查询的组件-->
            <form-lookup
                style="width: 150px; margin-right: 15px; float: left"
                v-model="filter.houseId"
                :options.sync="filter.roomList"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room />
            </form-lookup>

            <Select
                v-model="filter.status"
                style="width: 150px; margin-right: 20px; float: left"
                placeholder="工单状态"
                clearable
                @on-change="search"
            >
                <Option
                    v-for="item in dict.orderStatus.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>

            <Select
                v-model="filter.feeStatus"
                style="width: 150px; margin-right: 20px; float: left"
                placeholder="交费状态"
                clearable
                @on-change="search"
            >
                <Option
                    v-for="item in dict.cusPayStatusList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>

            <Select
                v-model="filter.dispatchType"
                style="width: 150px; margin-right: 20px; float: left"
                placeholder="委派类型"
                clearable
                @on-change="search"
            >
                <Option
                    v-for="item in dict.dispatchTypes.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>

            <filter-date-range
                placeStart="提交日期"
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="请输入工单号 或 提交人"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                v-if="$can('view')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:time="{ row, column }">
                <span>{{ getTime(row, column) }}</span>
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    :disabled="loading"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickView(row)"
                    >详情</Button
                >
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.page"
            @change="fetch"
        >
        </table-pager>
        弹出层
        <smart-modal
            v-model="modal.showInformation"
            :title="'工单详情'"
            :width="800"
            :maskClosable="false"
            :height="800"
            @close-by-confirm="search"
            :styles="{ top: '20px' }"
        >
            <order-tab
                v-if="modal.showInformation"
                :id="curId"
                :workOrder="curWorkOrder"
                :formMode="formMode"
                @search="search"
            >
            </order-tab>
        </smart-modal>
    </div>
</template>
<script>
import Dict from '_u/dict'
import { mapCache } from '@/plugins/vux-data-cache'
import mWorkOrderList from './m-work-order-list'

export default {
    name: 'keepclean-list',
    mixins: [mWorkOrderList],
    computed: {
        ...mapCache({
            filter: 'keepCleanFilter',
        }),
    },
}
</script>
<style lang="less" scope></style>
